import React, { lazy } from "react";
import { useParams } from "react-router-dom";

const InstagramUsernameGenerator = lazy(() => import("./Pages/InstagramUsernameGenerator"));
const TikTokUsernameGenerator = lazy(() => import("./Pages/TikTokUsernameGenerator"));
const YouTubeUsernameGenerator = lazy(() => import("./Pages/YouTubeUsernameGenerator"));
const TwitterUsernameGenerator = lazy(() => import("./Pages/TwitterUsernameGenerator"));
const PinterestUsernameGenerator = lazy(() => import("./Pages/PinterestUsernameGenerator"));
const FacebookUsernameGenerator = lazy(() => import("./Pages/FacebookUsernameGenerator"));
const SnapchatUsernameGenerator = lazy(() => import("./Pages/SnapchatUsernameGenerator"));
const ThreadsUsernameGenerator = lazy(() => import("./Pages/ThreadsUsrenameGenerator"));
const TwitchGamingUsernameGenerator = lazy(() => import("./Pages/TwitchGamingUsernameGenerator"));

export default function UsernameGenerator() {
  let { slug } = useParams();

  switch (slug) {
    case "instagram":
      return <InstagramUsernameGenerator />;

    case "tiktok":
      return <TikTokUsernameGenerator />;
    case "youtube":
      return <YouTubeUsernameGenerator />;
    case "twitter":
      return <TwitterUsernameGenerator />;
    case "pinterest":
      return <PinterestUsernameGenerator />;
    case "facebook":
      return <FacebookUsernameGenerator />;
    case "snapchat":
      return <SnapchatUsernameGenerator />;
    case "threads":
      return <ThreadsUsernameGenerator />;
    case "twitch-gaming":
      return <TwitchGamingUsernameGenerator />;
    default:
      return null;
  }
}
